/**
 * Small status pill beside a nav label (e.g. "Soon" on Lending). Screen readers
 * hear "(coming soon)" instead of the bare pill text.
 */
import { cn } from '@/lib/cn';

export function NavBadge({ label, className }: { label?: string; className?: string }) {
  if (!label) return null;
  return (
    <>
      <span
        aria-hidden="true"
        className={cn(
          'inline-flex h-[18px] items-center rounded-full bg-brand-500/[0.14] px-1.5 text-[10px] font-bold uppercase tracking-[0.06em] text-brand-200 ring-1 ring-inset ring-brand-400/25',
          className
        )}
      >
        {label}
      </span>
      <span className="sr-only">{label === 'Soon' ? ' (coming soon)' : ` (${label})`}</span>
    </>
  );
}
